import { useState } from 'react'

export function useLoginInputHook() {
  let defaultLoginInput = ''
  const storedLogin = window.localStorage.getItem('login')
  defaultLoginInput = storedLogin || ''

  const [loginInput, setLoginInput] = useState(defaultLoginInput)
  return [loginInput, setLoginInput]
}
